import {
  TableHead,
} from "@/components/shadcn/table";
import { Button } from "@/components/shadcn/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/shadcn/dropdown-menu";
import { Icon } from "@iconify-icon/solid";
import { cn } from "@/libs/cn";

export const TableViewHead = (props) => {
  const header = props.header;
  return (
    <TableHead colSpan={header.colSpan ?? 1}>
      {header.isPlaceholder
        ? null
        : (
          header.sort
            ? <DropdownMenu>
              <DropdownMenuTrigger as={(innerProps) => <Button variant={"ghost"}
                class={cn(
                  "justify-start text-left font-normal px-3 py-0 my-0",
                  "text-muted-foreground",
                  "py-0 my-0 h-auto"
                )} {...innerProps} />}>
                <span class="h-9 flex items-center gap-1">
                  {header.title}
                  <Icon icon={'akar-icons:arrow-up-down'} />
                </span>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                <DropdownMenuItem class="text-muted-foreground" onClick={() => {}}>
                  <Icon icon={'lucide:move-down'} />
                  <span class="text-xs">Asc</span>
                </DropdownMenuItem>
                <DropdownMenuItem class="text-muted-foreground" onClick={() => {}}>
                  <Icon icon={'lucide:move-up'} />
                  <span class="text-xs">Desc</span>
                </DropdownMenuItem>
                <DropdownMenuItem class="text-muted-foreground" onClick={() => {}}>
                  <Icon icon={'akar-icons:arrow-up-down'} />
                  <span class="text-xs">Reset</span>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
            : header.title
        )}
    </TableHead>
  );
}
